module.exports = __webpack_public_path__ + "static/media/overview.06f27db6.svg";